<template>
  <v-app>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-layout class="mt-1">
      <v-flex xs10 sm10 lg10 md10 offset-lg1 offset-md1 offset-sm1>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="project">
            <div>
              <span class="headline white--text"
                >{{ formTitle }}</span
              >
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="parseInt(editedItem.agent_task_assign_method_id) === 3 && hasAgent == true">
              <v-layout class="offset-3" row v-for="(element, index) in editedItem.assignAgentMemberInfo" :key="index">
                <v-flex xs3 sm12 md2>
                  <v-text-field
                    v-model="editedItem.assignAgentMemberInfo[index].agent_id"
                    box
                    label="Agent ID"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 sm12 md3>
                  <v-text-field
                    v-model="editedItem.assignAgentMemberInfo[index].phone"
                    box
                    label="phone"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3>
                  <v-text-field
                    v-model="
                      editedItem.assignAgentMemberInfo[index].agent_group_id
                    "
                    box
                    label="Agent Group ID"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3>
                  <v-text-field
                    numeric
                    v-model="
                      editedItem.assignAgentMemberInfo[index]
                        .number_of_allowed_task
                    "
                    box
                    label="Number of Allowed Task"
                    :rules="allowedTaskRules"
                    @keypress="isDigit($event)"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="parseInt(editedItem.agent_task_assign_method_id) === 2 && hasAgent == true">
              <v-layout row>
                <v-flex xs12 sm2 md2>
                  <v-text-field
                    v-model="editedItem.number_of_allowed_task"
                    box
                    label="Maximum allowed task"
                    :rules="allowedTaskRules"
                    disabled
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="editedItem.project_id && hasAgent === false">You have no agent to assign project task.</div>
          </v-card-text>
          <v-card-actions>
            <v-layout row>
              <v-btn class="button" flat @click="close">Cancel</v-btn>              
              <v-btn class="button" flat @click="save" :disabled="!hasAgent">Save</v-btn>
              <v-spacer></v-spacer>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
      </v-flex>
    </v-layout>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import { ROOT_URL } from "@/api/connectingUrls";
export default {
  data: () => ({
    valid: true,
    dialog: false,
    search: "",
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    apiUrl: "agent-group",
    editedIndex: -1,
    previousData: [],
    editedItem: {
      agent_group_id: null,
      projects: [],
      project_id: null,
      number_of_allowed_task: null,
      agent_task_assign_method_id: null,
      assignAgentMemberInfo: [],
    },
    defaultItem: {
      agent_group_id: null,
      project_id: null,
      agent_task_assign_method_id: null,
      assignAgentMemberInfo: [],
      number_of_allowed_task: null,
    },
    allowedTaskRules: [(v) => !!v || "This field is required"],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    hasProjects() {
      if (this.editedItem.projects) {
        return 1;
      } else {
        return 0;
      }
    },
    hasAgent() {
      // console.log(this.editedItem.assignAgentMemberInfo.length);
      if (this.editedItem.assignAgentMemberInfo.length>0) {
        return true;
      } else {
        return false;
      }
    },
    formTitle() {
      return this.editedIndex === -1
        ? "Assign Task Limit To Agents"
        : "Edit Url To Role";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.editedItem.project_id = project_id;
      this.$store.dispatch("setIndexData", [this.apiUrl]);
      // this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex = this.indexData.urlToRoles.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    isDigit(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[0-9]+$/.test(char)) return false;
      // Match with regex
      else {
        this.digitValidate = true;
        e.preventDefault();
      } // If not match, don't add to input text
    },

    deleteItem(item) {
      const index = this.indexData.urlToRoles.indexOf(item);
      var result =
        confirm("Are you sure you want to delete this item?") &&
        this.indexData.urlToRoles.splice(index, 1);
      if (result) {
        this.$store.dispatch("delete", [this.apiUrl, item.id]);
        this.initialize();
      }
    },
    async checkAssignment() {
      if (this.editedItem.project_id) {
        var projectIndex = this.editedItem.projects.findIndex(
          (x) => x.id === this.editedItem.project_id
        );
        // console.log(this.editedItem.projects[projectIndex]);
        this.editedItem.agent_task_assign_method_id =
          this.editedItem.projects[projectIndex].agent_task_assign_method_id;
        // if (this.editedItem.agent_task_assign_method_id == 3) {
        try {
          const token = window.localStorage.getItem("datadash_token");
          if (token != null) {
            const response = await axios.get(
              `${ROOT_URL}/agent-group-members-not-assigned?project_id=${this.editedItem.project_id}&agent_group_id=${this.editedItem.agent_group_id}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );
            if (response.data.statusCode == 200) {
              // console.log(response);
              this.editedItem.assignAgentMemberInfo =
                response.data.data.assignAgentMemberInfo;
            }
          }
        } catch (error) {
          // console.log(error);
        }
        // }
        // console.log(this.editedItem.agent_task_assign_method_id);
      }
    },
    async getProjects() {
      try {
        const token = window.localStorage.getItem("datadash_token");
        if (token != null) {
          const response = await axios.get(
            `${ROOT_URL}/agent-group-project-info/${this.editedItem.agent_group_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
          if (response.data.statusCode == 200) {
            // console.log(response);
            this.editedItem.projects = response.data.data.projectAgentGroup;
          }
        }
      } catch (error) {
        // console.log(error);
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.$refs.form.validate()) {
        // console.log(this.editedItem);
        this.$store.dispatch("storeOrUpdate", [
          "define.project-task",
          this.editedItem,
        ]);
        this.snackbar = true;
        this.close();
      }
      this.editedItem.project_id=null;
      this.editedItem.agent_group_id=null;
      this.editedItem.projects=[];
      this.editedItem.assignAgentMemberInfo=[];
    },
  },
};
</script>
<style scoped>
.tbl-border {
  border: 1px solid #000;
}
.table-th {
  border: 1px solid #000;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
